export type QueryValues = string | number | boolean | null | undefined | string[];

export type QueryParams = Record<string, QueryValues>;

/**
 * Собирает объект в query string.
 * null и undefined на первом уровне заменяются на пустые строки.
 */
export function encode(params: QueryParams): string {
    const res: [string, string][] = [];
    for (const [k, v] of Object.entries<QueryValues>(params)) {
        if (v === null || v === undefined) {
            res.push([k, '']);
        } else if (Array.isArray(v)) {
            res.push(...v.map<[string, string]>(s => [k, s]));
        } else {
            res.push([k, String(v)]);
        }
    }
    return new URLSearchParams(res).toString();
}

/**
 * Разбирает query string в объект.
 * Если ключи повторяются, преобразует их в массив (если не указать ignoreMulti = true).
 */
export function decode(query: string, ignoreMulti?: false): Record<string, string | string[]>;
export function decode(query: string, ignoreMulti: true): Record<string, string>;
export function decode(query: string, ignoreMulti = false): Record<string, string | string[]> {
    if (!query) {
        return {};
    }
    const params = new URLSearchParams(query);
    const res: Record<string, string | string[]> = {};

    for (const key of params.keys()) {
        const all = params.getAll(key);
        res[key] = (!ignoreMulti && all.length > 1) ? all : all[0];
    }

    return res;
}
